import type { ColumnOrderState } from '@tanstack/react-table';

import { getStoredTableValue, getTableLocalStorageKey, setStoredTableValue } from './table-local-storage';

const COLUMN_ORDER_STORAGE_PREFIX = 'savvy-data-table-column-order:';

function isStringArray(data: unknown): data is string[] {
  return Array.isArray(data) && data.every((value) => typeof value === 'string');
}

export function getColumnOrderStorageKey({
  tableName,
  storageKey,
  persist,
}: {
  readonly tableName: string | undefined;
  readonly storageKey: string | undefined;
  readonly persist: boolean;
}) {
  return getTableLocalStorageKey({ prefix: COLUMN_ORDER_STORAGE_PREFIX, tableName, storageKey, persist });
}

export function getStoredColumnOrder(storageKey: string) {
  return getStoredTableValue(storageKey, isStringArray);
}

export function setStoredColumnOrder({
  storageKey,
  columnOrder,
}: {
  readonly storageKey: string;
  readonly columnOrder: ColumnOrderState;
}) {
  setStoredTableValue(storageKey, columnOrder);
}
